import _ from 'lodash';

import { getConditionalArray } from 'utils/data';
import {
  checkIsDocumentUndeletable,
  checkIsMalwareBlocked,
  checkIsRecipientCopy,
} from 'utils/documents';

// Merging deletes its source documents, so a signed or undeletable document can't be a source.
export const checkIsDocumentMergeable = document =>
  !!document &&
  !document.isDeleted &&
  !checkIsMalwareBlocked(document.isMalware) &&
  !checkIsDocumentUndeletable(document);

export const checkCanMergeDocuments = (documents, documentIds) =>
  documentIds.every(documentId => checkIsDocumentMergeable(documents[documentId]));

// A click on a master row opens the document; only its copies toggle (or the keyboard)
// may expand it. Category and type ids are never keys of `documents`.
export const checkIsDocumentToggledByClick = ({
  event,
  prevExpandedItems,
  nextExpandedItems,
  documents,
}) =>
  event?.type === 'click' &&
  _.xor(prevExpandedItems, nextExpandedItems).some(itemId => !!documents[itemId]);

// Masters start collapsed even when open; an open copy opens its master.
export const getInitialExpandedItemIds = ({ categoriesIds, activeDocument, groupedCategories }) => {
  if (!activeDocument) {
    return categoriesIds;
  }

  const { documentTypeId } = activeDocument;

  return _.uniq([
    ...categoriesIds,
    ...groupedCategories[documentTypeId],
    documentTypeId,
    ...getConditionalArray(checkIsRecipientCopy(activeDocument), () => [
      activeDocument.RecipientCopyOf,
    ]),
  ]);
};
